import Selection from './support/selection'
import ConnectorsSelection from './support/connectors-selection'
import WobControls from './wob-controls-view'
import History from './support/history'
import Canvas from './canvas'
import _ from 'lodash'
import $ from 'jquery'
import * as d3 from 'd3-selection'
import leftClick from './left-click'
import { SnapType } from './support/snap'
import RTL from './support/rtl'

var EditableCanvas = Canvas.extend({

  className: 'editable-canvas',

  el: function () {
    var $el = Canvas.prototype.el.apply(this, arguments)

    $el.find('.wobs').after($('<div class="wobs-controls">'))
    return $el
  },

  events: {
    'select:element': 'selectEvent',
    'deselect:element': 'deselectEvent',
    'mousedown': 'deselectAllEvent',
    'touchstart': 'beginTouch',
    'start:marquee': 'selectionChange',
    'drag:rotate': 'resize',
    'end:marquee': 'selectionChange',
    'end:resize': function () {
      // Assign the callback as a function rather than a string in case the function is overridden
      this.correctBounds()
    },
    'end:dragging': function () {
      this.resize()
      this.correctBounds()
    }
  },

  initialize: function (options) {
    Canvas.prototype.initialize.apply(this, arguments)

    this.collection.snapType = SnapType.WIDGETS // Always snap to widgets unless told otherwise

    this.listenTo(this.collection, 'predestroy', _.bind(this.history.record, this.history))
    this.listenTo(this.collection, 'resize', this.resize, this)

    // If connectors are added on the wob, be sure to update our connectors selection
    this.listenTo(this.collection, 'connector:add', connector => {
      // Update the connectors selection
      this.connectorsSelection.add(connector)

      // New selector, set it to configurable
      var group = d3.select(`.connectors-container g.connector#connector-${connector.cid}`)
        , intersection = group.select('.connector-control-from-connection').node()
      connector.trigger('change:configurable', connector, true, intersection, group.datum().intersectionOffset)
    })
    this.listenTo(this.collection, 'connector:remove', connector => this.connectorsSelection.remove(connector))

  },

  add: function (wob) {
    // Add the wob on the canvas, which will create the actual wob view
    Canvas.prototype.add.apply(this, arguments)

    var wobView = this.views[wob.cid]

    // We also need the wob controls
    var control = new WobControls({
      model: wob,
      wobView: wobView,
      unpaddedControls: wobView.view.$el.hasClass('unpadded-resize-controls'),
      readonly: this.readonly,
      canvas: this
    })
    this.$('.wobs-controls').append(control.el)
    control.render()

    if (wobView.view.controlViewCls) {
      var widgetViewControl = new wobView.view.controlViewCls({
        container: wobView.$el,
        canvas: this,
        widgetView: wobView.view,
        model: wob.widget,
      })

      control.addWidgetViewControl(widgetViewControl)
      wobView.controlView = control
    }
  },

  /*
   * Fired after the user has grabbed wobs using the marquee and after click events to select/deselect
   * wobs.
   */
  selectionChange: function () {
    // The actual selection object may need to be rendered
    this.selection.group()
  },

  /*
   * widget: Widget the wob is holding
   * data: Predefined properties for this wob. Used for dropping images to a specific location
   * files: If the wob contains files (e.g. image)
  */
  create: function (_wob, files, opt) {
    opt = _.defaults(_.cloneDeep(opt))

    var self = this
    this.history.record()

    if (_.isUndefined(_wob.widget)) {
      throw new Error('wob need a widget')
    }

    _wob = _.defaults(_wob, $(window).width() > 480 ? {top: 110, left: 310} : {top: 0, left: 0}) // start at 0,0 on mobile

    var wob = this.collection.create(_wob, {
      success: function (w) {
        // Fire a custom event which contains the files
        wob.trigger('saved', files)

        if (opt.select) {
          // Clear all previous selected wobs, and select the new wob.
          self.selection.clear()
          self.selection.add(wob)
        }
      },
      error: function (wob) {
        // TODO indicate an error to the user saying we couldn't add their wob
        self.history.pop() // Remove the add history item
        self.views[wob.cid].release()
        wob.destroy()
        self.history.pop() // Remove the delete history item
        self.collection.trigger('change') // Trigger a change event so the history buttons in the dashbar know we popped history
      }
    })

    return wob
  },

  support: function () {
    Canvas.prototype.support.apply(this, arguments)
    this.rtl = new RTL(this)
    this.selection = new Selection({canvas: this})
    this.connectorsSelection = new ConnectorsSelection(this)
    this.history = new History(this)
  },

  setSnapType: function (type) {
    if (_.values(SnapType).indexOf(type) >= 0) {
      this.collection.snapType = type
    } else {
      throw new Error(`SnapType [${type}] not defined`)
    }

    this.$el.toggleClass('canvas-snap-grid', this.collection.snapType === SnapType.GRID)

    return this
  },

  /*
   * Aligns the selected wobs on the canvas at some position.
   * If the position is left, we use the leftmost wob and use that as the
   * authoritative source. If the position is right, we use the rightmost point.
   * Same applies for top and bottom.
   *
   * If the position is center or middle, we calculate the midpoint of the wobs and use that
   * for the src location
   *
   * position can be:
   *    left, center, right, top, middle, bottom
   */
  align: function (position) {
    if (['left', 'center', 'right', 'top', 'middle', 'bottom'].indexOf(position) === -1) {
      throw new Error('Invalid position')
    }
    this.selection.align(position)
  },

  /*
   * If the selection area is outside of the canvas,
   * send each element back into the canvas by that amount
   */
  correctBounds: function () {
    var area = this.selection.area()
      , move = {
        left: area.left < 0 ? area.left * -1 : 0,
        top: area.top < 0 ? area.top * -1 : 0
      }

    if (move.left || move.top) {
      this.selection.moveBy(move)
    }
  },

  // Implementation to actually resize the canvas in the DOM
  _resize: function () {
    var bb = this.boundingBox()

    this.trigger('resize', bb)

    this.$el.height(bb.maxY)
            .width(bb.maxX)
  },

  /*
   * Resizes the canvas.
   */
  resize: function () {
    if (!this.collection.ready) {
      // Ignore resizing the canvas until all wobs are ready so we don't thrash the browser
      return
    }

    // Can be expensive so make sure _resize is just called once
    this.queue.once(this._resize, this)
  },

  removeWob: function (wob) {
    var self = this

    if (!wob) {
      throw new Error('wob required')
    }

    if (wob.get('locked')) {
      return
    }

    this.selection.remove(wob)
    // If this wob had connectors, make sure we remove them from our connectorsSelection
    wob.get('connectors').forEach(connector => this.connectorsSelection.remove(connector))

    wob.destroy({
      error: function (model, xhr) {
        self.history.pop() // Remove the delete from history
        self.collection.add(model)
        self.history.pop() // Remove the add history item
        self.collection.trigger('change') // Trigger a change event so the history buttons in the dashbar know we popped history
      }
    })
  },

  removeSelected: function () {
    var self = this
    this.selection.wobs.forEach(this.removeWob.bind(this))

    this.connectorsSelection.connectors.forEach(connector => {
      // Find the wob that this connector comes from.
      // SpiderStrategies/Scoreboard#44915 don't use fromId because a new wob
      // won't have an ID yet. Instead, just look for the wob with the
      // connector model
      let wob = this.collection.find(w => {
        if (!w.get('connectors')) {
          return false
        }

        return !!w.get('connectors').find(c => c === connector)
      })

      if (wob) {
        this.history.record()
        // Remove the connector as long as the wob is still around.
        wob.get('connectors').remove(connector)
      }
    })
  },

  selectEvent: function (e, wob, multiple) {
    if (!multiple) {
      this.connectorsSelection.clear()
      this.selection.clear()
    }
    this.selection.add(wob.model)

    this.selectionChange()
    // make sure we blur any active elements https://github.com/SpiderStrategies/Scoreboard/issues/9372
    if (document.activeElement) {
      $(document.activeElement).blur()
    }
  },

  deselectEvent: function (e, wob, multiple) {
    if (multiple) {
      this.selection.remove(wob.model)
      this.selectionChange()
    }
  },

  deselectAll: function () {
    this.connectorsSelection.clear()
    return this.selection.clear()
  },

  deselectAllEvent: _.wrap(function (e) {
    if (e.target === e.currentTarget) {
      return this.deselectAll()
    }
  }, leftClick),

  beginTouch: function (e) {
    var self = this
      , moving = null

    // If user starts a touch, wait to see if they move
    this.$el.one('touchmove', function (e) {
      moving = true
    })

    this.$el.one('touchend', function (e) {
      // If they didn't do a touchmove, then run the deselect logic
      if (!moving) {
        self.deselectAllEvent(e)
      }
    })
  },

  release: function () {
    Canvas.prototype.release.apply(this, arguments)
    this.selection.clear()
    this.selection.release()
    this.history.release()

    this.features.forEach(function (feature) {
      try {
        feature.release()
      } catch (e) {
        // don't care
      }
    })

    this.collection = null
    this.remove()
    // Trigger a resize event so the scalable canvas knows to resize itself
    $(window).trigger('resize')
  }

})

export default EditableCanvas
